import { AppConfigurationClient } from '@azure/app-configuration';
import { AZURE_APP_CONFIG_CONNECTION_STRING } from './constants';

const connectionString: string = AZURE_APP_CONFIG_CONNECTION_STRING;
const configClient = new AppConfigurationClient(connectionString);
const maintenanceFlagKey: string = 'maintenancePage';
const disasterFlagKey: string = 'disasterPage';
const uri = window.location.href;
let environment = 'prod';
if (uri?.match('-uat')) environment = 'uat';
if (uri?.match('-test')) environment = 'test';
if (uri?.match('localhost')) environment = 'test';
const getFeatureFlag = async () => {
  try {
    let maintenanceEnabled = false;
    let disasterEnabled = false;
    const maintenanceFlag = await configClient.getConfigurationSetting({
      key: `.appconfig.featureflag/${maintenanceFlagKey.toString().trim()}`,
      label: environment,
    });
    const disasterFlag = await configClient.getConfigurationSetting({
      key: `.appconfig.featureflag/${disasterFlagKey.toString().trim()}`,
      label: environment,
    });

    if (maintenanceFlag && maintenanceFlag.tags && maintenanceFlag.value && typeof maintenanceFlag === 'object') {
      maintenanceFlag.tags['ttl'] = '0';
      await configClient.setConfigurationSetting(maintenanceFlag);
      maintenanceEnabled = JSON.parse(maintenanceFlag.value).enabled;
    }
    if (disasterFlag && disasterFlag.tags && disasterFlag.value && typeof disasterFlag === 'object') {
      disasterFlag.tags['ttl'] = '0';
      await configClient.setConfigurationSetting(disasterFlag);
      disasterEnabled = JSON.parse(disasterFlag.value).enabled;
    }
    if (maintenanceEnabled) return { flag: 'maintenance', maintenanceEnabled: true };
    if (disasterEnabled) return { flag: 'disaster', maintenanceEnabled: true };
    return { flag: 'main', maintenanceEnabled: false };
  } catch (error) {
    console.log(error);
    return { flag: 'main', maintenanceEnabled: false };
  }
};

export default getFeatureFlag;
